<template>
  <div>
    <b-modal id="my-modal-uuid" hide-footer hide-header size="lg" no-close-on-esc no-close-on-backdrop>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModalUuid()">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="d-block text-center" style="padding-top: 90px; padding-bottom: 55px;">
        <div class="" role="status">
          <span  class='fa fa-exclamation-circle iconSizeCheck colorYellow'></span>
        </div>
        <div class="modalNoPrebono mt-4">
          <span>Lo sentimos, en este momento el sistema se encuentra con problemas de intermitencia. Por favor guarda este código para entregárselo a soporte.</span>
        </div>
        <div class="modalNoPrebono"><br/>
          <span>Código de error:</span>
          <error-label />
        </div>
      </div>
    </b-modal>
    <b-modal id="my-modal-redirect" hide-footer hide-header size="lg" no-close-on-esc no-close-on-backdrop>
      <div class="d-block text-center" style="padding-top: 90px; padding-bottom: 55px;">
        <div class="" role="status">
          <span  class='fa fa-exclamation-circle iconSizeCheck colorYellow'></span>
        </div>
        <div class="modalNoPrebono mt-4">
          <span>Lo sentimos, en este momento el sistema se encuentra con problemas de intermitencia. Intente más tarde.</span>
        </div>
        <div class="mt-4"><br/>
          <span>Redireccionando</span><br/>
          <div class="spinner-border text-success" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal id="my-modal-logout" hide-footer hide-header size="lg" no-close-on-esc no-close-on-backdrop>
      <div class="d-block text-center" style="padding-top: 90px; padding-bottom: 55px;">
        <div class="" role="status">
          <span  class='fa fa-exclamation-circle iconSizeCheck colorYellow'></span>
        </div>
        <div class="modalNoPrebono mt-4">
          <span>Lo sentimos, en este momento el sistema se encuentra con problemas de intermitencia. Intente más tarde.</span>
        </div>
        <div class="mt-4"><br/>
          <span>Redireccionando</span><br/>
          <div class="spinner-border text-success" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal id="my-modal-exit" hide-footer hide-header size="md" no-close-on-esc no-close-on-backdrop>
      <div class="d-block text-center" style="padding-top: 90px; padding-bottom: 55px;">
        <div class="" role="status">
          <span  class='fa fa-exclamation-circle iconSizeCheck colorYellow'></span>
        </div>
        <div class="modalNoPrebono mt-4">
          <span>¿Estas seguro que deseas salir?</span>
        </div>
        <div class="mt-4"><br/>
          <button type="button" class="btn btn-primary" @click="exitRedirect">Aceptar</button>
          <button type="button" class="btn btn-light" @click="closeModal">Cancelar</button>
        </div>
      </div>
    </b-modal>
    <b-modal id="my-modal-skipPayment0" hide-footer hide-header size="xl" no-close-on-esc no-close-on-backdrop>
      <div class="d-block text-center" style="padding-top: 90px;">
        <div class="" role="status">
          <img src="/img/alert-exclamation.svg" class="d-block mx-auto mb-4 w-60p" alt="">
        </div>
        <div class="text-body mt-4">
          <span>El pago de la consulta la deberás realizar en forma presencial previo a la consulta médica, por favor llega 15 minutos antes de la hora reservada</span>
        </div>
        <div class="row">
          <div class="col-md-8 col-12 offset-0 offset-md-2 p-3">
            <div class="row">
              <div class="col-md-12 col-12 p-2">
                <button type="button" class="btn btn-custom" @click="skipRedirect0">Sí, entiendo</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal id="my-modal-skipPayment1" hide-footer hide-header size="xl" no-close-on-esc no-close-on-backdrop>
      <div class="row d-block text-center" style="padding-top: 90px;">
        <div class="col-12" role="status">
          <img src="/img/alert-exclamation.svg" class="d-block mx-auto mb-4 w-60p" alt="">
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-body mt-3">
          <span>El pago de la consulta la deberás realizar en forma previa a la video consulta, conéctate 15 minutos antes de la hora reservada</span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8 col-12 offset-0 offset-md-2 p-3">
          <div class="row">
            <div class="col-md-12 col-12 p-2">
              <button type="button" class="btn btn-custom" @click="skipRedirect1">Sí, entiendo</button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import { BModal, VBModal } from 'bootstrap-vue'

  export default {
    name: 'Modal',
    components: { BModal },
    directives: { 'b-modal': VBModal },
    methods:{
      closeModalUuid(){
        window.location.href = '/'
      },
      closeModal(){
        this.$root.$emit('bv::hide::modal', 'my-modal-exit')
      },
      exitRedirect(){
        localStorage.removeItem('simpleKey')
        localStorage.removeItem('isPerson')
        localStorage.removeItem('preBono')
        localStorage.removeItem('otherForm')
        window.location.href = "/api/logout"
      },
      closeModalSkip0(){
        this.$root.$emit('bv::hide::modal', 'my-modal-skipPayment0')
      },
      skipRedirect0(){
        localStorage.removeItem('simpleKey')
        localStorage.removeItem('isPerson')
        localStorage.removeItem('preBono')
        localStorage.removeItem('otherForm')
        localStorage.removeItem('selectedOffer')
        window.location.href = "/mimed/reservations"
      },
      closeModalSkip1(){
        this.$root.$emit('bv::hide::modal', 'my-modal-skipPayment1')
      },
      skipRedirect1(){
        localStorage.removeItem('simpleKey')
        localStorage.removeItem('isPerson')
        localStorage.removeItem('preBono')
        localStorage.removeItem('otherForm')
        localStorage.removeItem('selectedOffer')
        window.location.href = "/mimed/reservations"
      },
    }
  };
</script>

<style lang="css" scoped>
  .btn-custom{
    white-space: normal;
    width: 100%;
    height: 55px;
	  padding: 14px 10px;
    border-radius: 4px;
    background-color: #33cca0;
	  color: #FFFFFF;
	  font-weight: bold;
  }

  .btn-custom-secondary {
    white-space: normal;
    width: 100%;
    height: 55px;
	  padding: 14px 10px;
    border-radius: 4px;
    background-color: #e8faf5;
	  color: #33cca0;
	  font-weight: bold;
  }

  .text-body{
    font-family: "Poppins", sans-serif;
    font-size: 20px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.28px;
    text-align: center;
    color: #092f6d;
  }

  .w-60p{
    width: 60%;
  }
  .modal {
    background-color: rgba(0, 0, 0, 0.7);
  }
  .iconSizeCheck{
    font-size: 120px;
  }
  .colorYellow{
    color: #ffad01;
    margin-top: -6px;
  }
  .modalNoPrebono {
    font-family: "Poppins", sans-serif;
    font-size: 23px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.53px;
    text-align: center;
    color: #5c6670;
  }
  .RectangleBtnGreen{
    width: 197px;
    height: 45px;
    border-radius: 15px;
    box-shadow: 0 2px 10px 0 rgba(74, 74, 74, 0.5);
    background-color: #02b080;
    margin-top: 20px;
  }
  .paddingBtnProgreso{
    padding: 9px;
    color: #ffffff;
  }
  .CursorPointer{
    cursor: pointer;
  }
  .mt-8{
    margin-top: 6rem!important;
  }
</style>
